import { render, staticRenderFns } from "./alerts-item.vue?vue&type=template&id=78e8d0fb&scoped=true"
import script from "./alerts-item.vue?vue&type=script&lang=js"
export * from "./alerts-item.vue?vue&type=script&lang=js"
import style0 from "./alerts-item.vue?vue&type=style&index=0&id=78e8d0fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e8d0fb",
  null
  
)

export default component.exports